import { ZoneEntry } from '@ixicare/resources';
import * as React from 'react';
import { MapEvent } from '~config/map';
import styles from './DrawToolMap.module.css';
import DynamicMap from '~/components/Map/DynamicMap';
import { MapPostEventWrapperRef } from '~/components/Map/MapPostEventWrapper'; // Import the ref interface

interface DrawToolMapProps {
  siteId: number;
  planeUuid: string;
  isCreate?: boolean;
  zones: ZoneEntry[];
  onZoneSelect: (zoneUuid: string) => void;
  onZoneDrawCreateOrUpdate: (geo: any) => void;
}

const DrawToolMap = React.forwardRef<MapPostEventWrapperRef, DrawToolMapProps>( // Update forwardRef types
  (
    { siteId, planeUuid, zones, onZoneSelect, onZoneDrawCreateOrUpdate },
    ref // Receive the ref here
  ) => {
    const geofenceMap = ref as React.RefObject<MapPostEventWrapperRef>; // Cast the forwarded ref
    const [isFloorLoaded, setIsFloorLoaded] = React.useState(false);

    React.useEffect(() => {
      if (!zones.length || !isFloorLoaded) return;
      geofenceMap.current?.sendEvent(MapEvent.ZoneDrawZonesChanged, zones);
    }, [zones, isFloorLoaded]);

    React.useEffect(() => {
      geofenceMap.current?.listenToEvent(MapEvent.ZoneDrawingCreatedUpdated, onZoneDrawCreateOrUpdate);
    }, [onZoneDrawCreateOrUpdate]);
    React.useEffect(() => {
      geofenceMap.current?.listenToEvent(MapEvent.ZoneDrawZoneClick, onZoneSelect);
    }, [onZoneSelect]);

    return (
      <div className={styles.DrawToolMap}>
        <DynamicMap
          page="draw-tool"
          siteId={siteId}
          planeUuid={planeUuid}
          safeAreaTop={10}
          onFloorLoaded={() => setIsFloorLoaded(true)}
          height={'100vh'}
          ref={geofenceMap} // Pass the forwarded ref to DynamicMap
        />
      </div>
    );
  }
);

DrawToolMap.displayName = 'DrawToolMap';

export default DrawToolMap;
